<div class="sidebar-page-content copo-no-user-select sidenav-content" cdkScrollable *ngIf="!submitting; else spinner">
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>guarantee.request.list</span>	
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input [placeholder]="'search.placeholder' | translate" matInput type="text" spellcheck="false" autocomplete="off"
				[formControl]="searchTextControl"/>
			<button type="button" class="mat-button-close" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
	<div class="copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
	(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
		<!-- primary layout which is displayed by request-block-normal style on big resolutions -->
		<div class="request-block request-block-normal">
			<div *ngFor="let request of scroller.list" class="request-block-item">
				<div class="request-block-identity">
					<div class="request-block-title">{{request.name}}</div>
					<button type="button" mat-raised-button class="request-certificate-button"
						*ngIf="isSatisfied(request)" [disabled]="requestingCertificate"
						(click)="requestCertificate(request)">
						<span translate>guarantee.certificate.request</span>
					</button>
					<div class="pill request-block-status" [class.request-status-bg-draft]="isDraft(request)"
						[class.request-status-bg-open]="isOpen(request)"
						[class.request-status-bg-other]="isOther(request)"
						[class.request-status-bg-satisfied]="isSatisfied(request)"
						[class.request-status-bg-certificate-requested]="isCertificateRequested(request)"
						[class.request-status-bg-certificate-issued]="isCertificateIssued(request)"
						[class.request-status-bg-rejected]="isRejected(request)"
						[class.request-status-bg-cancelled]="isCancelled(request)"
						[class.request-status-bg-unknown]="isUnknown(request)">
						<span class="request-block-status-label">{{ getGuaranteeRequestStatusTr(request) }}</span>
					</div>
				</div>
				<div class="request-block-info">
					<div class="request-block-info-item">
						<div class="request-block-label" translate>guarantee.request.type</div>
						<div class="request-block-value">{{getLongType(request.applicationType)}}</div>
					</div>
					<div class="request-block-info-item">
						<div class="request-block-label" translate>guarantee.request.requested.date</div>
						<div class="request-block-value">{{request.requestDate | copoDate:'date'}}</div>
					</div>
					<div class="request-block-info-item">
						<div class="request-block-label" translate>guarantee.request.author</div>
						<div class="request-block-value">{{request.requesterName}}</div>
					</div>
					<div class="request-block-info-item">
						<div class="request-block-label" translate>guarantee.request.id</div>
						<div class="request-block-value">{{ request.guaranteeId ? request.guaranteeId :
							UNDERSCORE }}</div>
					</div>
					<div class="request-block-info-item">
						<div class="request-block-label" translate>guarantee.request.certificate.id</div>
						<ng-container *ngIf="request.certificateDocument as certificate; else noCertificate">
							<a class="request-block-value request-certificate-link" [title]="certificate.name" target="_blank"
								rel="noopener" [href]="getCertificateUrl(request, certificate) | copoSafeUrl">
								{{ certificate.name }}
							</a>
						</ng-container>
						<ng-template #noCertificate>{{ UNDERSCORE }}</ng-template>
					</div>
					<a mat-button class="request-block-details" [routerLink]="['/guarantee-requests/card/', request.id]">
						<span translate>quality.feedback.card.details</span>
						<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
					</a>
					<button type="button"  class="guarantee-placement-icon" mat-icon-button [matMenuTriggerFor]="menu">
						<mat-icon color="accent" svgIcon="md:more_vert"></mat-icon>
					</button>												
					<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
						<button type="button" mat-menu-item *ngIf="isDraft(request)"
							(click)="editDraft(request.id)">
							<span class="guarantee-color-tab" translate>edit.draft</span>
						</button>
						<button type="button" mat-menu-item *ngIf="isDraft(request)"
							(click)="evtDeleteDraft(request)">
							<span class="guarantee-color-tab" translate>quapp.action.delete</span>
						</button>
						<button type="button" mat-menu-item (click)="duplicateDetails(request.id)">
							<span class="guarantee-color-tab" translate>guarantee.request.duplicate</span>
						</button>
					</mat-menu>
				</div>
			</div>
		</div>
		<!-- additional layout which is displayed by request-block-small style on smaller resolutions -->
		<div class="request-block request-block-small">
			<div *ngFor="let request of scroller.list" class="request-block-item">
				<div class="request-block-identity">
					<div class="request-block-title">{{request.name}}</div>
					<button type="button" mat-raised-button class="request-certificate-button"
						*ngIf="isSatisfied(request)" [disabled]="requestingCertificate"
						(click)="requestCertificate(request)">
						<span translate>guarantee.certificate.request</span>
					</button>
					<div class="pill request-block-status" [class.request-status-bg-draft]="isDraft(request)"
						[class.request-status-bg-open]="isOpen(request)"
						[class.request-status-bg-other]="isOther(request)"
						[class.request-status-bg-satisfied]="isSatisfied(request)"
						[class.request-status-bg-certificate-requested]="isCertificateRequested(request)"
						[class.request-status-bg-certificate-issued]="isCertificateIssued(request)"
						[class.request-status-bg-rejected]="isRejected(request)"
						[class.request-status-bg-cancelled]="isCancelled(request)"
						[class.request-status-bg-unknown]="isUnknown(request)">
						<span class="request-block-status-label">{{request.status}}</span>
					</div>
				</div>
				<div class="request-block-info">
					<div class="request-col-half">
						<div class="request-block-info-item request-block-info-item-separated">
							<div class="request-block-label" translate>guarantee.request.type</div>
							<div class="request-block-value">{{request.applicationType}}</div>
						</div>
						<div class="request-block-info-item request-block-info-item-separated">
							<div class="request-block-label" translate>guarantee.request.requested.date</div>
							<div class="request-block-value">{{request.requestDate | copoDate:'date'}}</div>
						</div>
					</div>
					<div class="request-col-half">
						<div class="request-block-info-item request-block-info-item-separated">
							<div class="request-block-label" translate>guarantee.request.author</div>
							<div class="request-block-value">{{request.requesterName}}</div>
						</div>
						<div class="request-block-info-item request-block-info-item-separated">
								<div class="request-block-label" translate>guarantee.request.certificate.id</div>
								<ng-container *ngIf="request.certificateDocument as certificate; else noCertificateSmall">
									<a class="request-block-value request-certificate-link" [title]="certificate.name" target="_blank"
										rel="noopener" [href]="getCertificateUrl(request, certificate) | copoSafeUrl">
										{{ certificate.name }}
									</a>
								</ng-container>
								<ng-template #noCertificateSmall>{{ UNDERSCORE }}</ng-template>
						</div>
					</div>
					<div class="request-col-full">
						<div class="request-block-info-item request-block-info-item-separated">
							<div class="request-block-label" translate>guarantee.request.id</div>
							<div class="request-block-value">{{ request.guaranteeId ? request.guaranteeId :
								UNDERSCORE }}</div>
						</div>
					</div>
				</div>	
				<a mat-button class="request-block-details" [routerLink]="['/guarantee-requests/card/', request.id]">
					<span translate>quality.feedback.card.details</span>
					<mat-icon iconPositionEnd svgIcon="md:chevron_right" color="accent"></mat-icon>
				</a>
				<button type="button"  class="guarantee-placement-icon" mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon color="accent" svgIcon="md:more_vert"></mat-icon>
				</button>												
				<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
					<button type="button" mat-menu-item *ngIf="isDraft(request)"
						(click)="editDraft(request.id)">
						<span class="guarantee-color-tab" translate>edit.draft</span>
					</button>
					<button type="button" mat-menu-item *ngIf="isDraft(request)"
						(click)="evtDeleteDraft(request)">
						<span class="guarantee-color-tab" translate>quapp.action.delete</span>
					</button>
					<button type="button" mat-menu-item (click)="duplicateDetails(request.id)">
						<span class="guarantee-color-tab" translate>guarantee.request.duplicate</span>
					</button>
				</mat-menu>
			</div>
		</div>
	</div>
	<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>